﻿const svgs = document.querySelectorAll('[data-svg]');

document.addEventListener('DOMContentLoaded', function (event) {
  svgs.forEach((svg, index, parent) => {

	let options = JSON.parse(svg.dataset.svg);
	let target = document.querySelector(options.targetSelector);
	let inDebounce;
	svg.addEventListener('keyup', function (e) {
	  clearTimeout(inDebounce);
	  inDebounce = setTimeout(function () {
		target.innerHTML = svg.value;
	  }, 500);
	  
	});
  });
});
